import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { Field, useFormikContext } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const CheckboxInput: React.FC<Props> = (props) => {
  const { commonAttrs, classes, specificAttrs, values: options } = props;
  const { name, id } = commonAttrs;
  const { handleChange, setFieldValue } = useFormikContext<{
    [key: string]: string;
  }>();
  const { validate } = useFormContext();
  const use_label_element = specificAttrs.includes("use_label_element");
  const exclusive = specificAttrs.includes("exclusive");
  const { containerElementRef, fieldRef } = useFocusInvalidField(name, true);

  const content = (op: string, index: number) => (
    <>
      <Field
        type={"checkbox"}
        name={name}
        id={id}
        value={op}
        validate={(v: any) => validate(name, v)}
        onChange={(e: any) => {
          if (exclusive) {
            if (e.target?.checked) {
              const es = document.getElementsByName(name);
              es.forEach((f) => {
                if (f !== e.target) {
                  (f as HTMLInputElement).checked = false;
                }
              });
              setFieldValue(name, [op]);
            } else setFieldValue(name, []);
          } else handleChange(e);
        }}
        innerRef={(el: HTMLElement) => {
          if (index === 0) fieldRef.current = el;
        }}
      />
      <span
        className={classNames(
          "pr-2 font-normal align-middle",
          use_label_element ? "wpcf7-list-item-label" : "inline-block"
        )}
      >
        {toFarsiNumber(op)}
      </span>
    </>
  );
  return (
    <>
      <span
        className={classNames(classes.join(" "), exclusive ? "" : "")}
        ref={containerElementRef}
      >
        {options.map((op, idx) => (
          <span
            key={idx}
            className={
              use_label_element
                ? "px-0 flex flex-col  mb-0 mr-6"
                : "form-check mr-2"
            }
          >
            {use_label_element ? (
              <label className="">{content(op, idx)}</label>
            ) : (
              content(op, idx)
            )}
          </span>
        ))}
      </span>
    </>
  );
};

export default CheckboxInput;
